(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-b2b"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.currentScript?.closest('.nana-b2b') || document.querySelector('.nana-b2b');
  if (!root) return;
  if (new URLSearchParams(window.location.search).has('preview_theme_id')) document.documentElement.classList.add('nana-b2b-preview');
  const storageKey = 'nana-b2b-order-v1';
  const money = value => new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(Number(value || 0));
  const read = () => { try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch { return []; } };
  const write = items => { localStorage.setItem(storageKey, JSON.stringify(items)); render(); };
  const countEl = root.querySelector('[data-order-count]');
  const totalEl = root.querySelector('[data-order-total]');
  const itemsEl = root.querySelector('[data-order-items]');
  const dialog = root.querySelector('[data-order-dialog]');
  const render = () => {
    const items = read();
    if (countEl) countEl.textContent = items.reduce((s,i)=>s+i.qty,0);
    if (totalEl) totalEl.textContent = money(items.reduce((s,i)=>s+(i.price*i.qty),0));
    if (itemsEl) itemsEl.innerHTML = items.length ? items.map((i,index)=>`<div class="nana-b2b__order-row"><div><p><strong>${i.title}</strong></p><small>${i.variant} · ${i.sku || ''} · ${money(i.price)} × ${i.qty}</small></div><button type="button" data-remove="${index}">Rimuovi</button></div>`).join('') : '<p>Nessun articolo inserito.</p>';
  };
  root.addEventListener('change', e => {
    const select = e.target.closest('[data-variant-select]');
    if (!select) return;
    const card = select.closest('.nana-b2b-card');
    const option = select.options[select.selectedIndex];
    card.dataset.variantId = option.value;
    card.dataset.variantTitle = option.dataset.title || '';
    card.dataset.sku = option.dataset.sku || '';
    card.dataset.price = option.dataset.price || '';
    const priceEl = card.querySelector('[data-card-price]');
    const skuEl = card.querySelector('[data-card-sku]');
    const add = card.querySelector('[data-add-item]');
    if (priceEl) priceEl.textContent = option.dataset.priceLabel || '—';
    if (skuEl) skuEl.textContent = option.dataset.sku || '—';
    if (add) add.disabled = !option.dataset.price || option.dataset.available !== 'true';
  });
  root.addEventListener('click', e => {
    const filter = e.target.closest('[data-filter-group][data-filter-value]');
    if (filter) {
      const group = filter.dataset.filterGroup;
      root.querySelectorAll(`[data-filter-group="${group}"]`).forEach(b=>b.classList.remove('is-active'));
      filter.classList.add('is-active');
      const selected = {};
      ['category','price','finish','availability'].forEach(name => {
        selected[name] = root.querySelector(`[data-filter-group="${name}"].is-active`)?.dataset.filterValue || 'all';
      });
      root.querySelectorAll('.nana-b2b-item').forEach(item => {
        const categoryOk = selected.category === 'all' || (selected.category === 'nuovi-arrivi' ? item.dataset.newArrival === 'true' : item.dataset.category === selected.category);
        const priceOk = selected.price === 'all' || item.dataset.priceBand === selected.price;
        const finishOk = selected.finish === 'all' || item.dataset.finish === selected.finish;
        const availabilityOk = selected.availability === 'all' || item.dataset.available === 'true';
        item.hidden = !(categoryOk && priceOk && finishOk && availabilityOk);
      });
      return;
    }
    const add = e.target.closest('[data-add-item]');
    if (add) {
      const card = add.closest('.nana-b2b-card');
      const qty = Math.max(1, Number(card.querySelector('[data-qty]').value || 1));
      const price = Number(card.dataset.price || 0);
      if (!price) return;
      const items = read();
      const key = `${card.dataset.productId}-${card.dataset.variantId}`;
      const existing = items.find(i=>i.key===key);
      if (existing) existing.qty += qty;
      else items.push({key,title:card.dataset.title,variant:card.dataset.variantTitle,sku:card.dataset.sku,price,qty});
      write(items);
      return;
    }
    const remove = e.target.closest('[data-remove]');
    if (remove) { const items = read(); items.splice(Number(remove.dataset.remove),1); write(items); return; }
    if (e.target.closest('[data-order-open]')) { render(); dialog?.showModal(); return; }
    if (e.target.closest('[data-order-close]')) { dialog?.close(); return; }
    if (e.target.closest('[data-order-clear]')) { write([]); return; }
    const wa = e.target.closest('[data-whatsapp]');
    if (wa) {
      const items = read();
      if (!items.length) return;
      const customer = root.querySelector('[data-customer-name]')?.value.trim() || '';
      const total = items.reduce((s,i)=>s+(i.price*i.qty),0);
      const lines = ['ORDINE B2B NANÀ', customer ? `Negozio: ${customer}` : '', '', ...items.map(i=>`${i.qty}x ${i.title} - ${i.variant} - ${i.sku || 'senza codice'} - ${money(i.price)} cad.`), '', `Totale IVA esclusa: ${money(total)}`].filter(Boolean);
      const phone = ((wa.dataset.phone || '').replace(/\D/g,'') || '393336998960');
      const url = `https://wa.me/${phone}?text=${encodeURIComponent(lines.join('\n'))}`;
      window.location.href = url;
    }
  });
  root.querySelectorAll('[data-variant-select]').forEach(select => select.dispatchEvent(new Event('change',{bubbles:true})));
  render();
})();

  } catch(e) { console.error(e); }
})();
})();
